<button
  (click)="onClick()"
  class="favorite-btn"
  [class.favorited]="isFavorited"
  [class.loading]="isLoading"
  [class.animating]="isAnimating"
  [class.pulse]="showPulse"
  [class.unfavorite-shake]="isAnimating && !isFavorited"
  [disabled]="disabled || isLoading"
  [title]="title"
>
  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-spinner"></div>

  <!-- Main heart icon -->
  <div class="heart-container" [class.hidden]="isLoading">
    <span class="heart-icon">
      {{ isFavorited ? '❤️' : '🤍' }}
    </span>

    <!-- Heart burst animation -->
    <div *ngIf="showHeartBurst" class="heart-burst">
      <span class="burst-heart">❤️</span>
      <span class="burst-heart">❤️</span>
      <span class="burst-heart">❤️</span>
      <span class="burst-heart">❤️</span>
      <span class="burst-heart">❤️</span>
      <span class="burst-heart">❤️</span>
    </div>
  </div>

  <!-- Pulse ring effect -->
  <div *ngIf="showPulse" class="pulse-ring"></div>
</button>
